////namespace SP {
////    export interface VendorInfo {
////        id: string;
////        name: string,
////        uniqueVendorCode: string,
////        address: Address
////    }
////}